import { createComponent, ElementWithProps } from '@carvana/merch-components';
import cx from 'classnames';
import { MouseEventHandler } from 'react';
import { PrimaryButton } from '@/common/Button';

const DefaultWrapper = createComponent<ElementWithProps<{ onVDP: boolean }>>(
  'div',
  props => ({
    className: cx(
      'flex flex-col justify-between rounded-[6px] border border-grey-2 bg-cover bg-center p-2xl text-white',
      {
        'max-w-[680px] m:mx-auto m:grid m:grid-cols-[1fr_184px] m:items-center m:gap-xl m:bg-[center_top_35%]':
          props.onVDP
      }
    )
  })
);

type OwnProps = {
  ctaProps: {
    dataAnalyticsId: string;
    dataAnalyticsAttributes?: string;
    dataNativePayload?: string;
    dataQa?: string;
    href: string;
    onClick?: MouseEventHandler<HTMLAnchorElement>;
  };
  onVDP?: boolean;
};

export default function DefaultTradeCard({
  ctaProps,
  onVDP = false
}: OwnProps) {
  const backgroundImage = `${process.env.CVNA_APP_CDN_ASSETS_PATH}/images/stc-background-7-24.png`;

  return (
    <DefaultWrapper
      onVDP={onVDP}
      data-qa="apply-trade-in-card"
      style={{
        backgroundImage: `url(${backgroundImage})`
      }}
    >
      <div
        className={cx('flex flex-auto flex-col gap-xl pb-xl', {
          'm:pb-0': onVDP
        })}
      >
        <h3 className="tl-header-m" data-qa="trade-card-heading">
          Sell/Trade Your Car
        </h3>
        <p className="tl-body-m" data-qa="no-trade-paragraph">
          Get a real offer in less than 2 minutes — sell, trade or track your
          value.
        </p>
      </div>
      <a
        className="w-full"
        data-analytics-id={ctaProps.dataAnalyticsId}
        data-analytics-attributes={ctaProps.dataAnalyticsAttributes}
        data-native-payload={ctaProps.dataNativePayload}
        data-qa={ctaProps.dataQa}
        href={ctaProps.href}
        onClick={ctaProps.onClick}
      >
        <PrimaryButton className="h-40 min-h-40 w-full !px-12" mode="dark">
          get your offer
        </PrimaryButton>
      </a>
    </DefaultWrapper>
  );
}
